import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { flowRight } from "lodash";
import Header from "./Header";

const Layout = ({ location, history, children }) => {
  const currentUrl = window.location.href;

  return (
    <Fragment>
        <Header location={location} currentUrl={currentUrl} history={history} />
        <div className="app-body flex-column-div overflow-scroll">
            {children}
        </div>
    </Fragment>
  );
};

export default flowRight(withRouter)(Layout);
